// 生成クライアントの care-protocol レスポンスは unknown 型のため、
// フロントで扱う形をここで定義してキャストに使う。

/** ケアプロトコルを出し分けるスコア（0は表示対象外）。 */
export const CARE_PROTOCOL_SCORES = [1, 2] as const;
export type CareProtocolScore = (typeof CARE_PROTOCOL_SCORES)[number];

/** OHAT項目(1..8) × スコア(1|2) ごとのケアプロトコル。 */
export type CareProtocolItem = {
  item: number; // OHAT項目 1..8
  score: number; // 対象スコア 1|2
  content: string;
  isCustom: boolean; // true=組織カスタム, false=共通デフォルト
};

/** item と score の組み合わせを Map のキーにする。 */
export const careProtocolKey = (item: number, score: number) =>
  `${item}:${score}`;
